import Vue from 'vue'
import App from './App'
import './scss/main.scss'

Vue.config.productionTip = false
new Vue({
  el: '#app',
  template: '<App/>',
  components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js